import { useEffect, useState } from "react";
import "./styles.css";

import icon from "../../assets/right_arrow.png";

const CTAForm = (props) => {
  const [text, setText] = useState("Fale com um especialista");

  useEffect(() => {
    if (props.text !== undefined) setText(props.text);
  }, [props.text]);

  return (
    <button id="ctaForm">
      <a href="#form">
        <p>{text}</p>

        <figure>
          <img src={icon} alt="Ícone do Formulário" />
        </figure>
      </a>
    </button>
  );
};

export default CTAForm;
